export default {
  my_scroll: "",
  setScroll(value){
    this.my_scroll = value
  }
}


// WEBPACK FOOTER //
// ./src/config/global.js